import React from 'react';

export const timezone = "Australia/Sydney";

export const decodeOtherLanguage = function (strToDecode) {
    const result = decodeURIComponent(escape(window.atob(strToDecode)));
    return result === 'null'?'':result;
};

export const setCustomInputStyling = function (primaryColor) {
    var primaryColorUrlSafe = encodeURIComponent(primaryColor);
    return (
        <style dangerouslySetInnerHTML={{
            __html: `
        .tx .custom-control-label::before {
            border: 2px solid `+ primaryColor + `;
        }
        .custom-radio input:checked~.custom-control-label::after {
          background-image: url('data:image/svg+xml;utf8,<svg fill="`+ primaryColorUrlSafe + `" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 8" style="enable-background:new 0 0 8 8;" xml:space="preserve"><circle class="st0" cx="4" cy="4" r="3"/></svg>');
        }
        .custom-checkbox input:checked~.custom-control-label::after {
          background-image: url('data:image/svg+xml;utf8,<svg fill="`+ primaryColorUrlSafe + `" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 8" style="enable-background:new 0 0 8 8;" xml:space="preserve"><path class="st0" d="M6.6,0.8L3,4.4L1.4,2.8L0,4.3l3,3l5-5.1L6.6,0.8z"/></svg>');
        }
      `}}></style>
    );
};

export const showEmbedFooter = function() {
  const url = new URL(window.location);
  let showEmbedFooter = false;
  if (url) {
    const params = new URLSearchParams(url.search);
    if (params) {
      showEmbedFooter = (params.get("embed") && params.get("embed") === 'true')?true:false;
      console.log('showFooter ', showEmbedFooter);
    }
  }
  return showEmbedFooter;
};

export const getUrlWord = function (urlPath, hash = null) {
  // [hash removal] remove this after hash migration
  if (hash && hash != '') {
    return hash.replace(/(^#)/g, "");
  }
  let urlArray = urlPath.split('/');
  if (urlArray[1] && urlArray[1] != '' && urlArray[2] && urlArray[2] != '') {
    return `/${urlArray[1]}/${urlArray[2]}`;
  }
  console.log('window', '__CURL_' + window.location.hostname.replace(/\./g, "_"));
  return '__CURL_' + window.location.hostname.replace(/\./g, "_");
};

export const returnValueIfNotEmpty = (input) => {
  return (typeof input != "undefined") ? input : '';
}

export const isValidJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const convertTZ = (date, tzString = timezone) => {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

export const setSessionValidity = (idComp) => {
  // midnight
  let validTime = convertTZ(new Date()).setHours(24,0,0,0);
  localStorage.setItem(`${idComp}-sessionValidity`, validTime);
  return true;
}

export const isSessionActive = (idComp) => {
  let validTime = localStorage.getItem(`${idComp}-sessionValidity`);
  if (validTime) {
    validTime = parseInt(validTime);
  }
  let currentTime = convertTZ(new Date()).getTime();
  console.log('currenttime', currentTime);
  console.log('validtime', validTime);
  console.log('sessionActive', validTime > currentTime);
  return (validTime && validTime > currentTime);
}

export const clearSession = (idComp) => {
  localStorage.removeItem(`${idComp}-idOptin`);
  localStorage.removeItem(`${idComp}-idVote`);
  localStorage.removeItem(`${idComp}-offer`);
  localStorage.removeItem(`${idComp}-optData`);
  localStorage.removeItem(`${idComp}-offerViewed`);
  localStorage.removeItem(`${idComp}-orderPaid`);
  localStorage.removeItem(`${idComp}-sessionValidity`);
}

export const getGlobalCode = (code) => {
  if (code && code != '') {
    return window.atob(code);
  } else {
    return '';
  }
}

export const injectGlobalCode = ($, htmlTag, code) => {
  if (code && code != '' && code.trim().length > 0) {
    var targetHtmlElement = $(htmlTag);
    if (targetHtmlElement) {
      targetHtmlElement.append(code);
    }
  }
}

export const getUrlExtension = (url) => {
  return url.split(/[#?]/)[0].split('.').pop().trim();
}

export const getVideoExtensions = (url) => {
  return ['mp4', 'avi', 'webm', 'mov']
}

export const isVideo = (url) => {
  var urlExt = getUrlExtension(url);
  return (getVideoExtensions().includes(urlExt));
}

export const lightenHex = (hex, percent) => {
  // normalize and remove '#'
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) {
    // throw new Error('Invalid hex');
    hex = '#999999';
  }

  const num = parseInt(hex, 16);
  let r = (num >> 16) & 0xFF;
  let g = (num >> 8) & 0xFF;
  let b = num & 0xFF;

  const clamp = v => Math.max(0, Math.min(255, Math.round(v)));

  // percent: 0..100 (positive to lighten, negative to darken)
  const factor = (percent / 100);
  r = clamp(r + (255 - r) * factor);
  g = clamp(g + (255 - g) * factor);
  b = clamp(b + (255 - b) * factor);

  const toHex = v => v.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
